import { Entity, FiltersRelativeDateMethod, MetadataAttachment, MetadataEntityData, MetadataEntityFieldEditorType } from '@jms/model';
import { EntityFilterDataSource, EntityFilterDropDownOption, EntityPickerOptionDisplay } from '@workbuddy/ui/fields/entity.filter';
import * as Enumerable from 'linq';
import { AllowedPickType } from '../model';

export interface FilesFilterDataSourceValue {
    createdBy: Entity[];
    createdDate: FiltersRelativeDateMethod,
    entityName: Entity[];
    tags: Entity[];
    type: Entity[];
    kind: Entity[];
}

export function getFilesFilterDataSource(
    entity: MetadataEntityData,
    attachments: MetadataAttachment[],
    allowedTypes?: AllowedPickType[]
): EntityFilterDataSource {

    const filters = Enumerable
        .from(entity.fields)
        .where(x => {

            // Hide the type filter if the allowedTypes is set, we don't want to show it in the filter panel
            if (x.name === 'type') {
                if (allowedTypes?.length) {
                    return false;
                }
            }

            return x.filterable;
        })
        .toArray();

    const dropdownOptions = Enumerable
        .from(filters)
        .where(x => x.filterType == MetadataEntityFieldEditorType.Dropdown)
        .toObject(x => x.name, x => ({ style: EntityPickerOptionDisplay.Text, options: [] as Entity[] }));

    const getEntity = (v: any) => {
        if (v?._id) {
            return v;
        } else {
            return { _id: v, name: v };
        }
    }

    Enumerable
        .from(attachments)
        .forEach(x => {

            Enumerable
                .from(Object.keys(dropdownOptions))
                .forEach(key => {

                    const dropdownOption = dropdownOptions[key];
                    const value = x[key];

                    if (Array.isArray(value)) {
                        Enumerable
                            .from(value)
                            .forEach(v => {
                                dropdownOption.options.push(getEntity(v))
                            });
                    } else {
                        dropdownOption.options.push(getEntity(value))
                    }
                })

        });

    Enumerable
        .from(Object.keys(dropdownOptions))
        .forEach(key => {

            const dropdownOption = dropdownOptions[key] as EntityFilterDropDownOption;
            dropdownOption.options = Enumerable
                .from(dropdownOption.options)
                .where(x => !!x?._id)
                .distinct(x => x._id)
                .orderBy(x => x.name)
                .toArray();

        });


    return {
        entity,
        filters,
        dropdownOptions: dropdownOptions as any
    }


}